










































































































import Loading from 'vue-loading-overlay';
import { Watch, Component, Prop, Vue, Emit, Mixins } from 'vue-property-decorator';
import {
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { Mounted } from '../../core/decorators';
import FormAbm from '../../journeys/components/FormAbm.vue';
import ModalConfirmation from '../../home/components/ModalConfirmation.vue';
import { JourneysService } from '../../journeys/api/JourneysService';
import { EventBus, ID, TypeEventBus } from '../../core/utils';
import Axios from 'axios';

@Component({
    components: { Loading, FormAbm, ModalConfirmation }
})
export default class ModalJourneyABM extends Mixins(
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
) {
    @Prop() show: boolean;
    @Prop() modalData: any;
    @Prop() previousJourneyData: object;
    @Prop() journeyExist: boolean;
    @Prop({ default: false }) fromActions: boolean;
    @Prop({default: -1}) journeyCalcType: ID;
    hourTypes: Array<object> = [];
    postJson: object = {};
    showModal: boolean = false;
    formValid: boolean = false;
    pendingRequest: boolean = false;
    enableSubmit: boolean = false;
    cancelToken: any | null = null;
    showModalConfirmation: boolean = false;
    actionJourney: string = '';
    updateOriginalValuesOnPatch: boolean = false;
    journeyWasDeleted: boolean = false;
    journeyWasRestored: boolean = false;
    defaultJourneyCalcTypes: Array<object> = [
        {
            "description": "Tipo N",
            "value": 0
        },
        {
            "description": "Tipo H",
            "value": 1
        },
        {
            "description": "Tipo TH",
            "value": 2
        },
        {
            "description": "Tipo I",
            "value": 3
        }
    ]
    journeysCalcTypes: Array<object> = []

    mounted(){
        
    }

    created(){
        
        
    }

    getJourneysCalcTypes(){
        if(this.journeysCalcTypes.length > 0) return

        JourneysService.getJourneyCalcTypes()
        .then((res) => {
            this.journeysCalcTypes = res;
        }).catch((err) => {
            this.journeysCalcTypes = this.defaultJourneyCalcTypes
        })
    }
    

    setModalConfirmationVisibility(value) {
        this.showModalConfirmation = value;
    }

    @Watch('$_getJourneyHourTypes', { deep: true, immediate: true })
    updateJourneyHourTypes(value) {
        this.hourTypes = value;
    }

    @Watch('show')
    observableShow(value) {
        if (value) {
             this.getJourneysCalcTypes();
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }

        this.showModal = value;
    }

    keydownEnterEvent() {
        if (this.modalData.form.action === 'forzar-cierre') {
            this.closeModal();
        }
    }

    get formJourney(): HTMLFormElement {
        return this.$refs.formJourney as HTMLFormElement;
    }

    get modalConfirm(): HTMLFormElement {
        return this.$refs.modalConfirmation as HTMLFormElement;
    }

    get getEnableSubmit() {
        if (this.modalData.form.action !== 'forzar-cierre') {
            return !this.enableSubmit;
        } else {
            return this.modalData.isClosing;
        }
    }

    closeJourney() {
        let modalConf = this.$refs.modalConfirmation as HTMLFormElement;
        let companyId = this.$_getSelectedCompanyById as number;
        this.cancelToken = Axios.CancelToken.source();
        let journeyId = this.$route.params.id;
        let configuration = {
            journey_list: [journeyId],
            company_id: Number(companyId)
        };

        JourneysService.postCloseJourney(configuration)
            .then(response => {
                this.$emit('update-journey-status', response[journeyId]['new_registry']['event']);
                EventBus.$emit(TypeEventBus.EVENTS_REFRESHED, response, true);
                modalConf.changeModalQuestion(response[journeyId]['message']);
                modalConf.actionCompleted();
                this.$emit('get-journey-information');
            })
            .catch(error => {
                let _this = this;
                if (error && error.response && error.response.data && error.response.data.message) {
                    modalConf.changeModalQuestion(error.response.data.message);
                    if (error.response.data.message === 'La jornada solicitada no está en curso') {
                        _this.$emit('get-journey-information');
                    }
                } else {
                    modalConf.changeModalQuestion('Ocurrió un error');
                }
                modalConf.actionCompleted();
            });
    }

    restoreJourney() {
        this.journeyWasRestored = false;
        this.cancelToken = Axios.CancelToken.source();
        let journeyId = this.$route.params.id;
        let data = {
            journey_list: [journeyId]
        };
        let modalConf = this.$refs.modalConfirmation as HTMLFormElement;
        JourneysService.restoreJourneyById(data)
            .then(response => {
                this.journeyWasRestored = true;
                this.$emit('update-journey-status', response[journeyId].new_registry.event);
                modalConf.changeModalQuestion(response[journeyId].message);
                modalConf.actionCompleted();
                EventBus.$emit(TypeEventBus.EVENTS_REFRESHED, response, true);
            })
            .catch(error => {
                if (error && error.response && error.response.data && error.response.data.message) {
                    modalConf.changeModalQuestion(error.data.message);
                } else {
                    modalConf.changeModalQuestion('Ocurrió un error');
                }
                modalConf.actionCompleted();
            });
    }

    deleteJourney() {
        this.journeyWasDeleted = false;
        let modalConf = this.$refs.modalConfirmation as HTMLFormElement;
        let journeyId = this.$route.params.id;
        let data = { journey_list: [journeyId] };
        JourneysService.deleteJourneyById(data, false)
            .then(response => {
                this.journeyWasDeleted = true;
                // console.log(response);
                this.$emit('update-journey-status', response[journeyId].new_registry.event);
                modalConf.changeModalQuestion(response[journeyId].message);
                modalConf.actionCompleted();
                this.$emit('update-journey-list');
                EventBus.$emit(TypeEventBus.EVENTS_REFRESHED, response, true);
            })
            .catch(error => {
                // console.log(error);
                if (error && error.message) {
                    modalConf.changeModalQuestion(error.message);
                } else {
                    modalConf.changeModalQuestion('Ocurrió un error');
                }
                modalConf.actionCompleted();
            });
    }

    patchJourney() {
        this.cancelToken = Axios.CancelToken.source();
        let formElement = this.$refs.formJourney as HTMLFormElement;
        let modalConf = this.$refs.modalConfirmation as HTMLFormElement;
        let self = this;
        let journeyId = this.$route.params.id;
        let formData = formElement.getFormattedData();
        JourneysService.patchJourneyById(formData, journeyId)
            .then(response => {
                this.$emit('update-journey-data', response.data.journey);
                modalConf.changeModalQuestion(response.data.message);
                modalConf.actionCompleted();
                EventBus.$emit(
                    TypeEventBus.EVENTS_REFRESHED,
                    {
                        [journeyId]: response.data
                    },
                    true
                );
            })
            .catch(error => {
                // console.log(error);
                if (error && error.response && error.response.data && error.response.data.message) {
                    modalConf.changeModalQuestion(error.data.message);
                } else {
                    modalConf.changeModalQuestion('Ocurrió un error');
                }
                modalConf.actionCompleted();
            });
    }

    getOriginalValues() {
        this.pendingRequest = true;
        JourneysService.getJourneyInformation(this.$route.params.id, false, this.cancelToken, true).then(data => {
            this.$emit('update-modal-journey-data', data);
            this.pendingRequest = false;
        });
    }

    updateFormData(data) {
        if (this.formJourney) {
            this.formJourney.setFormData(data);
        }
    }

    submitJourney() {
        this.formJourney.submitForm();
    }

    getDisabledAction(action) {
        return this.getEnableSubmit;
    }

    closeModal() {
        if (this.modalData.form.action === 'edit') {
            if (this.actionJourney === 'restoreJourney' && this.journeyWasRestored) {
                this.previousJourneyData['deleted'] = false;
            } else if (this.actionJourney === 'deleteJourney' && this.journeyWasDeleted) {
                this.previousJourneyData['deleted'] = true;
            }
            this.$emit('update-form-data', this.previousJourneyData);
        }
        this.modalVisibility(false);
        this.$emit('close-modal');
        this.$emit('cancel-loading');
    }

    modalVisibility(value) {
        this.showModal = value;
    }

    triggerAction(action) {
        if (action === 'close-modal') {
            this.closeModal();
        } else if (action === 'createJourney') {
            // this.formJourney.submitForm();
            this.actionJourney = 'createJourney';
            this.setModalConfirmationVisibility(true);
            // this.formJourney.checkIfAssignedHoursAreEqualToTotal();
        } else if (action === 'deleteJourney') {
            this.actionJourney = 'deleteJourney';
            this.setModalConfirmationVisibility(true);
        } else if (action === 'modifyJourney') {
            this.actionJourney = 'modifyJourney';
            this.setModalConfirmationVisibility(true);
        } else if (action === 'loadOriginalValues') {
            this.actionJourney = 'loadOriginalValues';
            this.setModalConfirmationVisibility(true);
        } else if (action === 'forceCloseJourney') {
            if (this.fromActions) {
                this.forceCloseJourneys();
            } else {
                this.actionJourney = 'forceCloseJourney';
                this.setModalConfirmationVisibility(true);
            }
        } else if (action === 'restoreJourney') {
            this.actionJourney = 'restoreJourney';
            this.setModalConfirmationVisibility(true);
        } else {
            this.$emit('open-confirmation-dialog', action);
        }
    }

    submitVisibility(value) {
        this.enableSubmit = value;
    }

    finishJourneyPost(data) {
        if (data.status) {
            this.modalConfirm.enableJourneyDetail(data.id);
            this.modalConfirm.changeModalQuestion(data.msg);
            this.modalConfirm.actionCompleted();
            this.formJourney.resetForm();
            this.$emit('update-journey-list');
        } else {
            this.modalConfirm.changeModalQuestion(data.msg);
            this.modalConfirm.actionCompleted();
        }
    }

    updateModalData() {
        this.formJourney.resetForm();
    }

    @Emit()
    forceCloseJourneys() {}

    postJourneyError(){
        this.setModalConfirmationVisibility(false);
    }
}
